import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowTableBody: Components<Theme>['MuiTableBody'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      borderColor: 'inherit',
    },
  },
};
